module.exports = __webpack_public_path__ + "media/terroir-explorable.b258e82d.webm";